module.exports = __webpack_public_path__ + "img/com_balitbang.f4619198.png";